import { NetmisUserRoleDto } from "../../roles/dtos/NetmisUserRoleDto";

export class SetUserRoleActiveDto {
  providerId: string;
  constructor(dto?: NetmisUserRoleDto) {
    this.providerId = dto?.provider.id || "";
  }
}
